module.exports = __webpack_public_path__ + "static/img/bundles-tv.f13e92d7.svg";